import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'

const useStyles = makeStyles(trueOrFalseStyles)

export default function TrueOrFalse ({context, section, question, questionIndex}) {

  const classes = useStyles()
  const [answer, setAnswer] = React.useState(question.answer.value)

  const {translate} = context

  React.useEffect(() => {
    setAnswer(question.answer.value)
  }, [question])

  return (
    <Box className={classes.root}>
      <RadioGroup className="content" value={question.answer.value}>
        <Box className={classes.option}>
          <Box className={classes.radio}>
            <FormControlLabel value={true} control={<Radio />} label={translate('true')} />
          </Box>
        </Box>
        <Box className={classes.option}>
          <Box className={classes.radio}>
            <FormControlLabel value={false} control={<Radio />} label={translate('false')} />
          </Box>
        </Box>
      </RadioGroup>
    </Box>
  )
}

function trueOrFalseStyles (theme) {
  return {
    root: {
    },
    option: {
      display: 'flex'
    }
  }
}
